import React from 'react'
import useCardContext from './useCardContext'
import { CardContextProps } from './types'

const withCardContext = <WrappedProps extends CardContextProps>(
  WrappedComponent: React.ComponentType<WrappedProps>
) => {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  const WithCardContext = React.forwardRef<typeof WrappedComponent, Omit<WrappedProps, keyof CardContextProps>>((props, ref) => {
    const cardContext = useCardContext()

    return (
      <WrappedComponent
        {...props as WrappedProps}
        ref={ref}
        cardContext={cardContext}
      />
    )
  })

  WithCardContext.displayName = `withCardContext(${displayName})`

  return WithCardContext
}

export default withCardContext

